import { render } from "./myAddress.vue?vue&type=template&id=c7c77fc8"
import script from "./myAddress.vue?vue&type=script&lang=js"
export * from "./myAddress.vue?vue&type=script&lang=js"

import "./myAddress.vue?vue&type=style&index=0&id=c7c77fc8&lang=less"

import exportComponent from "D:\\project\\Mase_Customer\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__